import { ModelBase } from 'store/model-base';
import { INSUFFICIENT_AUTH_METHODS } from 'core/constants';

export class NowPortOutAuthCheck extends ModelBase {
    public static storeName: string = 'nowPortOutAuthCheck';

    public decision: string; // value will be 'permit' or 'deny'
    public authorizationBaseUrl?: string;
    public authorizationAltBaseUrl: string;
    public reason: string;
    public isInsufficientAuthMethods: boolean;

    public static create<T extends ModelBase>(initData: object): T {
        const toReturn: NowPortOutAuthCheck = super.create<NowPortOutAuthCheck>(initData);
        toReturn.isInsufficientAuthMethods = toReturn.reason?.toLocaleLowerCase() === INSUFFICIENT_AUTH_METHODS;      

        return super.create<T>(toReturn);
    }
}
